import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static values = {
        allCompanyIds: { type: Array, default: [] },
        currentCompanies: { type: Array, default: [] },
        companies: { type: Array, default: [] }
    }
    static targets = ["select"]

    connect() {
        this.setupSelectFiltering();
    }

    setupSelectFiltering(attempt = 0) {
        const tomselect = this.getTomSelect();
        if (!tomselect) {
            const maxAttempts = 50
            if (attempt >= maxAttempts) {
                console.error('TomSelect did not initialize after maximum attempts.');
                return;
            }
            requestAnimationFrame(() => this.setupSelectFiltering(attempt + 1));
            return;
        }

        // Store the original load function
        const originalLoad = tomselect.settings.load.bind(tomselect);

        // Wrap the load function to filter out already-added companies
        tomselect.settings.load = (query, callback) => {
            originalLoad(query, (data) => {
                const filteredData = data ? data.filter(item =>
                    !this.currentCompaniesValue.includes(parseInt(item.id))
                ) : [];
                callback(filteredData);
            });
        };

        // Trigger initial load to populate options
        tomselect.load('');
    }

    getTomSelect() {
        if (!this.hasSelectTarget) return null;
        const selectElement = this.selectTarget.querySelector('select');
        return selectElement ? selectElement.tomselect : null;
    }

    addAllCompanies() {
        if (confirm('Are you sure you want to add all companies to the KB sync list?')) {
            this.updateCompanies(this.allCompanyIdsValue);
        }
    }

    removeAllCompanies() {
        if (confirm('Are you sure you want to remove all companies from the KB sync list?')) {
            this.updateCompanies([]);
        }
    }

    removeCompany(event) {
        const companyId = parseInt(event.currentTarget.dataset.companyId);
        if (confirm('Are you sure?')) {
            const updatedCompanies = this.currentCompaniesValue.filter(id => id !== companyId);
            this.updateCompanies(updatedCompanies);
        }
    }

    addSelections() {
        const tomselect = this.getTomSelect();
        if (tomselect) {
            const selectedIds = tomselect.getValue().map(id => parseInt(id));
            const updatedCompanies = [...new Set([...this.currentCompaniesValue, ...selectedIds])];
            this.updateCompanies(updatedCompanies);
        }
    }

    updateCompanies(companyIds) {
        // Update the hidden input field as a comma-separated string value
        const hiddenInput = this.element.querySelector('input[name="integrator[kb_sync_companies]"]');
        if (hiddenInput) {
            hiddenInput.value = companyIds.join(',');
        }

        this.currentCompaniesValue = companyIds;
        this.refreshSelectOptions();
        this.updateDisplayList(companyIds);
    }

    refreshSelectOptions() {
        const tomselect = this.getTomSelect();
        if (!tomselect) return;

        tomselect.clear();
        tomselect.clearOptions();
        tomselect.load('');
    }

    updateDisplayList(companyIds) {
        const memberList = this.element.querySelector('.groups__member-list');
        if (!memberList) return;

        memberList.innerHTML = '';
        if (companyIds.length === 0) {
            memberList.innerHTML = '<p class="text--empty">None. This integration will not sync any KB articles from companies.</p>';
        } else {
            // Sort companies by name
            companyIds = companyIds.sort((a, b) => {
                const companyA = this.companiesValue.find(c => c.id === a);
                const companyB = this.companiesValue.find(c => c.id === b);
                return (companyA?.name || '').localeCompare(companyB?.name || '');
            });

            const ul = document.createElement('ul');
            companyIds.forEach(companyId => {
                const company = this.companiesValue.find(c => c.id === companyId);
                if (company) {
                    const li = document.createElement('li');
                    li.innerHTML = `
                        <a href="/c/${company.slug}" target="_blank">${company.name}</a>
                        <div class="button-group">
                            <button type="button" data-action="click->kb-sync-companies#removeCompany" data-company-id="${companyId}" class="button button--danger-tertiary">Remove</button>
                        </div>
                    `;
                    ul.appendChild(li);
                }
            });
            memberList.appendChild(ul);
        }
    }
}
